import { useEffect, useState } from 'react';
import { api, type User } from '../lib/api';
import { AppNav } from '../components/AppNav';

export function Users() {
  const [items, setItems] = useState<User[]>([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', displayName: '' });
  const [err, setErr] = useState<string | null>(null);
  const [resetFor, setResetFor] = useState<string | null>(null);
  const [newPass, setNewPass] = useState('');

  useEffect(() => { reload(); }, []);
  async function reload() { setItems((await api.listUsers()).items); }

  async function create() {
    setErr(null);
    try {
      await api.createUser(form);
      setForm({ email: '', password: '', displayName: '' });
      setCreating(false);
      reload();
    } catch (e: any) { setErr(String(e.message)); }
  }

  async function reset(id: string) {
    if (newPass.length < 8) return setErr('Password >= 8 chars');
    await api.resetPassword(id, newPass);
    setResetFor(null); setNewPass('');
  }

  async function del(id: string) {
    if (!confirm('Eliminar usuario?')) return;
    try { await api.deleteUser(id); reload(); } catch (e: any) { alert(e.message); }
  }

  return (
    <div>
      <AppNav />
      <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
        <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h1 style={{ margin: 0, fontSize: 22 }}>Usuarios</h1>
          <button onClick={() => setCreating(c => !c)} style={btn('primary')}>+ Nuevo usuario</button>
        </header>

        {creating && (
          <div style={{ border: '1px solid #cbd5e1', padding: 16, borderRadius: 8, marginBottom: 16, display: 'grid', gap: 8 }}>
            <Input label="Email"     v={form.email}        on={v => setForm({...form, email: v})} type="email" />
            <Input label="Password" v={form.password}     on={v => setForm({...form, password: v})} type="password" />
            <Input label="Nombre"   v={form.displayName}  on={v => setForm({...form, displayName: v})} />
            {err && <p style={{ color: '#dc2626', fontSize: 13, margin: 0 }}>{err}</p>}
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={create} style={btn('primary')}>Crear</button>
              <button onClick={() => setCreating(false)} style={btn('ghost')}>Cancelar</button>
            </div>
          </div>
        )}

        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead><tr style={{ borderBottom: '1px solid #e2e8f0', textAlign: 'left', color: '#64748b', fontSize: 11, textTransform: 'uppercase' }}>
            <th style={th}>Email</th><th style={th}>Nombre</th><th style={th}>Creado</th><th style={th}></th>
          </tr></thead>
          <tbody>
            {items.map(u => (
              <tr key={u.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={td}>{u.email}</td>
                <td style={td}>{u.displayName ?? '—'}</td>
                <td style={td}>{new Date(u.createdAt).toLocaleDateString()}</td>
                <td style={{ ...td, textAlign: 'right' }}>
                  <button onClick={() => setResetFor(u.id)} style={btn('ghost')}>Reset pass</button>
                  <button onClick={() => del(u.id)} style={{ ...btn('ghost'), color: '#dc2626', borderColor: '#fecaca', marginLeft: 4 }}>Eliminar</button>
                  {resetFor === u.id && (
                    <div style={{ display: 'flex', gap: 4, marginTop: 4, justifyContent: 'flex-end' }}>
                      <input type="password" value={newPass} onChange={e => setNewPass(e.target.value)} placeholder="nueva pass (>=8)" style={{ ...inp, width: 180 }} />
                      <button onClick={() => reset(u.id)} style={btn('primary')}>OK</button>
                      <button onClick={() => { setResetFor(null); setNewPass(''); }} style={btn('ghost')}>×</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Input(p: { label: string; v: string; on: (s: string) => void; type?: string }) {
  return (
    <label>
      <span style={{ display: 'block', fontSize: 11, color: '#475569', marginBottom: 4 }}>{p.label}</span>
      <input value={p.v} onChange={e => p.on(e.target.value)} type={p.type ?? 'text'} style={inp} />
    </label>
  );
}

const inp: React.CSSProperties = { width: '100%', padding: '6px 8px', border: '1px solid #cbd5e1', borderRadius: 4, boxSizing: 'border-box', fontSize: 13 };
const th: React.CSSProperties = { padding: '8px 10px', fontWeight: 500 };
const td: React.CSSProperties = { padding: '8px 10px' };
const btn = (k: 'primary' | 'ghost'): React.CSSProperties => k === 'primary'
  ? { padding: '6px 12px', background: '#0ea5e9', color: 'white', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' }
  : { padding: '4px 10px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 12, cursor: 'pointer' };
